import CoursewareItemProvider from 'services/coursewareItem/CoursewareItemProvider';
import CoursewareTargetProvider from 'services/coursewareTarget/CoursewareTargetProvider';
import ThemeResolver from './ThemeResolver';

class ThemeProvider {
  constructor() {
    this._targetId = null;
  }

  async getTargetId(id) {
    const target = await CoursewareTargetProvider.createCoursewareTarget(id);
    const rootTarget = target.ancestry.slice(-1)[0];
    this._targetId = rootTarget ? rootTarget.elementId : id;
    return this._targetId;
  }

  async getInTheme(id, path = []) {
    const targetId = this._targetId || await this.getTargetId(id);
    return CoursewareItemProvider.getInCoursewareTheme(targetId, path);
  }

  async getThemeVariants(id) {
    const targetId = this._targetId || await this.getTargetId(id);
    return (await ThemeResolver.getThemeVariants(targetId))?.selectedThemePayload;
  }

  async getThemeVariant(themeId, variantId) {
    return (await ThemeResolver.getThemeVariant(themeId, variantId))?.themeVariant;
  }

  async setInTheme(id, theme, path = []) {
    const targetId = this._targetId || await this.getTargetId(id);
    return CoursewareItemProvider.setInCoursewareTheme(targetId, theme, path);
  }

  async subscribeToTheme(id, path, callBackFn, coursewareId) {
    const targetId = this._targetId || await this.getTargetId(id);
    const listener = (themeConfig) => {
      const processConfig = async () => Promise.resolve(themeConfig);
      processConfig().then((config) => callBackFn(config));
    };
    return CoursewareItemProvider.subscribeToCoursewareTheme(
      targetId,
      listener,
      path,
      coursewareId,
      id
    );
  }
}

export default new ThemeProvider();
